import React from "react";
import { Link } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import { getSession } from "./apiConfig";

const CATEGORY_TILES = [
  {
    section: "Master",
    desc: "Party, Product, Employee, Company, Tax & Parameters",
    to: "/party-master",
    icon: "📋",
  },
  {
    section: "Transactions",
    desc: "AWB In / Out Entry, Party Transactions",
    to: "/admin/AwbIn",
    icon: "🧾",
  },
  {
    section: "Reports",
    desc: "Invoice Print, AWB List, Ledger",
    to: "/reports",
    icon: "📊",
  },
  {
    section: "Final Reports",
    desc: "Trial Balance, Profit & Loss, Balance Sheet",
    to: "/reports",
    icon: "📈",
  },
  {
    section: "GST Reports",
    desc: "GST Excel Sheet",
    to: null,
    icon: "🧮",
  },
  {
    section: "Other Reports",
    desc: "Customer List, Employee List",
    to: null,
    icon: "👥",
  },
  {
    section: "Utility",
    desc: "Backup, Recalculations, WhatsApp Message",
    to: null,
    icon: "⚙️",
  },
];

const AdminPanel = ({ awbData = [] }) => {
  const session = getSession();

  return (
    <AdminLayout awbData={awbData}>
      <style>{`
        .dash-welcome { margin-bottom: 1.5rem; }
        .dash-welcome h1 { margin: 0 0 4px 0; font-size: 1.5rem; color: #0f172a; }
        .dash-welcome p { margin: 0; color: #64748b; font-size: 0.9rem; }
        .stat-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; margin-bottom: 2rem; }
        .stat-grid .card h3 { margin: 0 0 6px 0; font-size: 0.8rem; color: #64748b; text-transform: uppercase; letter-spacing: 0.03em; }
        .stat-grid .card p { margin: 0; font-size: 1.6rem; font-weight: bold; color: #0f172a; }

        .tile-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 1rem; margin-bottom: 2rem; }
        .tile-card {
          background: white; border: 1px solid #e2e8f0; border-radius: 10px;
          padding: 1.25rem; text-decoration: none; color: inherit;
          transition: box-shadow 0.15s, transform 0.15s;
          display: block; box-shadow: 0 1px 3px rgba(0,0,0,0.06);
        }
        .tile-card:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.1); transform: translateY(-2px); }
        .tile-card.disabled { opacity: 0.55; cursor: not-allowed; pointer-events: none; }
        .tile-icon { font-size: 1.8rem; margin-bottom: 0.5rem; }
        .tile-title { font-weight: 600; font-size: 1rem; color: #0f172a; margin-bottom: 4px; }
        .tile-desc { font-size: 0.8rem; color: #64748b; line-height: 1.4; }
        .tile-soon { display: inline-block; margin-top: 8px; font-size: 0.65rem; background: #f1f5f9; color: #94a3b8; padding: 2px 8px; border-radius: 10px; }

        .recent-table-wrap { overflow-x: auto; }
      `}</style>

      <div className="dash-welcome">
        <h1>Welcome{session?.User_Name ? `, ${session.User_Name}` : ""}</h1>
        <p>Pick a category below to get started, or view your recent shipment activity.</p>
      </div>

      <div className="stat-grid">
        <div className="card">
          <h3>Total Shipments</h3>
          <p>{awbData.length}</p>
        </div>
        <div className="card">
          <h3>Avg Weight</h3>
          <p>
            {(
              awbData.reduce((acc, curr) => acc + (curr.weight || 0), 0) /
              (awbData.length || 1)
            ).toFixed(2)}{" "}
            kg
          </p>
        </div>
        <div className="card">
          <h3>Status</h3>
          <p style={{ fontSize: "1.1rem" }}>Active</p>
        </div>
      </div>

      <div className="tile-grid">
        {CATEGORY_TILES.map((tile) =>
          tile.to ? (
            <Link key={tile.section} to={tile.to} className="tile-card">
              <div className="tile-icon">{tile.icon}</div>
              <div className="tile-title">{tile.section}</div>
              <div className="tile-desc">{tile.desc}</div>
            </Link>
          ) : (
            <div key={tile.section} className="tile-card disabled">
              <div className="tile-icon">{tile.icon}</div>
              <div className="tile-title">{tile.section}</div>
              <div className="tile-desc">{tile.desc}</div>
              <span className="tile-soon">Coming Soon</span>
            </div>
          )
        )}
      </div>

      <div className="card recent-table-wrap">
        <h3 style={{ marginTop: 0 }}>Recent AWB Activity</h3>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "left", padding: "8px" }}>AWB No</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Date</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Qty</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Weight</th>
            </tr>
          </thead>
          <tbody>
            {awbData.slice(0, 10).map((d, i) => (
              <tr key={i}>
                <td style={{ padding: "8px" }}>{d.awB_NO}</td>
                <td style={{ padding: "8px" }}>{d.awb_Dt?.split("T")[0]}</td>
                <td style={{ padding: "8px" }}>{d.qty}</td>
                <td style={{ padding: "8px" }}>{d.weight} kg</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
};

export default AdminPanel;